module.exports = __webpack_public_path__ + "img/2024121801.b55ed8c9.png";